import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e770bdb2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e770bdb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../paris-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e770bdb2",
  null
  
)

export default component.exports